<template>
  <div>
    <h1>Dashboard</h1>

    <!-- Loading state -->
    <div v-if="loading" class="dashboard-grid">
      <v-card
        v-for="n in 4"
        :key="n"
        color="grey lighten-3"
        class="skeleton-card"
      >
        <v-card-title>
          <v-skeleton-loader type="chip" width="40" class="mr-3" />
          <v-skeleton-loader type="heading" width="100" />
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-skeleton-loader type="text" width="80" class="mx-auto" />
        </v-card-text>
      </v-card>
    </div>

    <!-- Error state -->
    <div v-else-if="error" class="dashboard-grid">
      <v-card color="error" dark>
        <v-card-title>
          <v-icon large left> mdi-alert-circle </v-icon>
          <span class="title font-weight-light">Failed to load</span>
        </v-card-title>
        <v-card-text>{{ error }}</v-card-text>
      </v-card>
    </div>

    <!-- Cards -->
    <div v-else class="dashboard-grid">
      <v-card
        v-for="card in cards"
        :key="card.key"
        color="primary"
        dark
        class="dashboard-card"
      >
        <v-card-title>
          <v-icon large left> {{ card.icon }} </v-icon>
          <span class="title font-weight-light">{{ card.label }}</span>
        </v-card-title>
        <v-divider class="divider" />
        <v-card-text class="cardText">
          <div class="count">{{ card.value }}</div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import * as api from "@/api";

export default {
  name: "Dashboard",
  created() {
    this.getStatistic();
  },
  methods: {
    getStatistic() {
      this.loading = true;
      this.error = null;
      api
        .getAll("dashboard")
        .then((response) => {
          this.data = response.data[0];
          this.buildCards();
        })
        .catch((error) => {
          this.error = error.message || "Failed to load dashboard data";
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    buildCards() {
      const d = this.data || {};
      const fields = [
        { key: "PublicationCount",  icon: "mdi-book",               label: "eBooks" },
        { key: "JournalCount",      icon: "mdi-book-multiple",      label: "Journals" },
        { key: "OrganizationCount", icon: "mdi-domain",             label: "Organizations" },
        { key: "UserCount",         icon: "mdi-account",            label: "Users" },
      ];

      this.cards = fields.map((f) => ({
        ...f,
        value: d[f.key] ? d[f.key].toString() : "—",
      }));
    },
  },
  data() {
    return {
      data: {},
      cards: [],
      loading: true,
      error: null,
    };
  },
};
</script>
<style scoped>
.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 20px;
}

.dashboard-card {
  width: 100%;
}

.count {
  font-size: clamp(28px, 6vw, 72px);
  font-weight: 400;
  text-align: center;
  margin-top: 12px;
  color: white;
  line-height: 1.1;
}

.cardText {
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.title {
  text-align: center;
}

.divider {
  color: white;
  border-width: 1px;
}

/* Loading skeleton */
.skeleton-card {
  min-height: 160px;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue